'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, RefObject, useRef } from 'react';
import { useEventListener, useMediaQuery, useResizeObserver } from 'usehooks-ts';
import AppTopNav from '@/app/[locale]/(worlds)/components/AppTopNav';
import Loading from '@/components/Loading';
import { useLayoutContext } from '@/context/LayoutContext';
import { useRouteChangeContext } from '@/context/RouteChangeContext';
import { useUAContext } from '@/context/UAContext';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { useEnableFull3d } from '@/hooks/useEnableFull3d';
import { useScrollRestoration } from '@/hooks/useScrollRestoration';
import { cn } from '@/lib/utils';
import { NavItemType } from '@/types/nav';
type WorldSidebarContentProps = PropsWithChildren<{
  navItems: NavItemType[];
  navItemsMobile: NavItemType[];
  navItemsApp: NavItemType[];
  activeItem: string;
  itemRefs: RefObject<Record<string, HTMLAnchorElement | null>>;
}>;
function WorldSidebarContent(t0) {
  const $ = _c(24);
  const {
    children,
    navItemsApp,
    activeItem
  } = t0;
  const {
    headerHeight
  } = useLayoutContext();
  const {
    isRouteLoading
  } = useRouteChangeContext();
  const {
    deviceType,
    isMobileApp
  } = useUAContext();
  const {
    setMobileNavHeight
  } = useWorldSearchContext();
  const isMobileOrTablet = useMediaQuery("(max-width: 1023px)") || deviceType !== "desktop";
  const enableFull3d = useEnableFull3d();
  useScrollRestoration();
  const desktopNavRef = useRef(null);
  const mobileNavRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ref: desktopNavRef as RefObject<HTMLElement>,
      box: "border-box"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    width: t2
  } = useResizeObserver(t1);
  const desktopNavWidth = t2 === undefined ? 0 : t2;
  let t3;
  if ($[1] !== setMobileNavHeight) {
    t3 = () => {
      if (mobileNavRef.current) {
        const height = mobileNavRef.current.clientHeight;
        setMobileNavHeight(height);
      }
    };
    $[1] = setMobileNavHeight;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEventListener("resize", t3);
  const t4 = !isMobileApp && !enableFull3d;
  let t5;
  if ($[3] !== t4) {
    t5 = cn("flex h-dvh w-full", {
      "min-[1280px]:pl-15": t4
    });
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isMobileApp ? 0 : headerHeight;
  let t7;
  if ($[5] !== t6) {
    t7 = {
      paddingTop: t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== activeItem || $[8] !== isMobileApp || $[9] !== navItemsApp) {
    t8 = isMobileApp && <AppTopNav navItems={navItemsApp} activeItem={activeItem} />;
    $[7] = activeItem;
    $[8] = isMobileApp;
    $[9] = navItemsApp;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== desktopNavWidth || $[12] !== headerHeight || $[13] !== isMobileOrTablet || $[14] !== isRouteLoading) {
    t9 = !isMobileOrTablet && isRouteLoading && <div className="z-navigation fixed right-0 bottom-0" style={{
      left: desktopNavWidth,
      top: headerHeight
    }}><Loading absolute={true} disableLoader={true} fixed={false} /></div>;
    $[11] = desktopNavWidth;
    $[12] = headerHeight;
    $[13] = isMobileOrTablet;
    $[14] = isRouteLoading;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== children || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className="w-full overflow-hidden lg:w-auto lg:flex-1"><div className="relative h-full overflow-y-auto scroll-smooth" data-scroll-container={true}>{t8}{t9}{children}</div></div>;
    $[16] = children;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t7) {
    t11 = <div className={t5} style={t7}>{t10}</div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
export default WorldSidebarContent;